import * as React from 'react'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

export function BuyerFields({
  buyerName,
  buyerEmail,
  setBuyerName,
  setBuyerEmail,
}: {
  buyerName: string
  buyerEmail: string
  setBuyerName: (value: string) => void
  setBuyerEmail: (value: string) => void
}) {
  return (
    <>
      <Field label="Your name" id="event-buyer-name">
        <Input
          id="event-buyer-name"
          className="h-8 bg-background"
          value={buyerName}
          onChange={(event) => setBuyerName(event.target.value)}
          required
        />
      </Field>
      <Field label="Email" id="event-buyer-email">
        <Input
          id="event-buyer-email"
          type="email"
          className="h-8 bg-background"
          value={buyerEmail}
          onChange={(event) => setBuyerEmail(event.target.value)}
          required
        />
      </Field>
    </>
  )
}

export function AttendeeNameFields({
  attendees,
  attendeeLabels,
  setAttendees,
}: {
  attendees: string[]
  attendeeLabels: string[]
  setAttendees: React.Dispatch<React.SetStateAction<string[]>>
}) {
  return attendees.map((name, index) => (
    <Field
      key={index}
      label={`${attendeeLabels[index] ?? 'Attendee'} — attendee ${index + 1} name (optional)`}
      id={`attendee-${index}`}
    >
      <Input
        id={`attendee-${index}`}
        className="h-8 bg-background"
        value={name}
        onChange={(event) =>
          setAttendees((current) =>
            current.map((value, currentIndex) =>
              currentIndex === index ? event.target.value : value,
            ),
          )
        }
      />
    </Field>
  ))
}

function Field({ label, id, children }: { label: string; id: string; children: React.ReactNode }) {
  return (
    <div className="space-y-1.5">
      <Label htmlFor={id} className="text-caption text-muted-foreground">
        {label}
      </Label>
      {children}
    </div>
  )
}
